import React from "react"
import classes from "./grid.module.css"
import Single from "./single/single"
import image1 from "../../images/body1.jpg"
import image2 from "../../images/waxing1.jpg"
import image3 from "../../images/eyebrows1.jpg"

const grid2 = () => {
  return (
    <div className={classes.Grid}>
      <Single title="Body treatments" image={image1} link="/body-treatments" />
      <Single title="Waxing" image={image2} link="/waxing" />
      <Single
        title="Eyebrow and eyelash treatments"
        image={image3}
        link="/eyebrow-and-eyelash-treatments"
      />
    </div>
  )
}

export default grid2
